<template>
  <div>
    <div v-if="loading" class="clearfix">
      <b-spinner class="float-right" label="Carregando..." />
    </div>
    <FormPaymentReceiptAccount
      v-else
      title-form="Editar Transação Financeira"
      :combo-payment="comboFormaPagamento"
      :combo-type="comboTipoPagamento"
      :combo-situation="comboSituacao"
      :combo-account="comboContas"
      :object-edit="pagamentoRecebimento"
      @cancelar="cancelar"
      @save="save"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { BSpinner } from 'bootstrap-vue'
import FormPaymentReceiptAccount from '@/layouts/components/FormPaymentReceiptAccount.vue'
import mixinsGlobal from '@/mixins'

export default {
  name: 'TransacaoForm',
  components: { FormPaymentReceiptAccount, BSpinner },
  mixins: [mixinsGlobal],
  data() {
    return { loading: true }
  },
  computed: {
    ...mapState('combosModule', {
      comboFormaPagamento: state => state.comboFormaPagamento,
      comboTipoPagamento: state => state.comboTipoPagamento,
      comboContas: state => state.comboContas
    }),
    ...mapState('pagamentoRecebimentoFinancialModule', {
      pagamentoRecebimento: state => state.pagamentoRecebimento,
      comboSituacao: state => state.comboSituacao
    })
  },
  mounted() {
    this.carregarDados()
  },
  methods: {
    async carregarDados() {
      this.loading = true
      // 1. Resolve Combos Básicos e lista MACRO de Tipos de Pagamento
      await Promise.all([
        this.$store.dispatch('combosModule/loadComboFormaPagamento'),
        this.$store.dispatch('combosModule/loadComboTipoPagamento'),
        this.$store.dispatch('combosModule/loadComboContas'),
        this.$store.dispatch('pagamentoRecebimentoFinancialModule/resetFinancialAccount')
      ])
      
      // 2. Busca Objeto
      const result = await this.$store.dispatch(
        'pagamentoRecebimentoFinancialModule/getbyIdForEdit',
        this.$route.params.id
      )
      const obj = result.data

      // 3. Normaliza IDs para o V-Select
      obj.tipo = obj.tipo.id
      obj.formaPagamento = obj.formaPagamento.id
      if (obj.conta) obj.conta = obj.conta.id
      
      await this.$store.dispatch(
        'pagamentoRecebimentoFinancialModule/prepareToEditFinancialAccount',
        obj
      )
      this.loading = false
    },

    // Retorna à tela de Transações Financeiras (não ao Contas a Pagar padrão)
    voltar() {
      this.$store.dispatch('pagamentoRecebimentoFinancialModule/resetFinancialAccount')
      this.$router.push({ name: 'transacoesFinanceiras' })
    },

    cancelar() {
      this.voltar()
    },

    prepareForSave(data) {
      const d = JSON.parse(JSON.stringify(data))
      return {
        id: d.id,
        registro: d.registro,
        descricao: d.descricao,
        dataLancamento: d.dataLancamento,
        dataVencimento: d.dataVencimento,
        dataQuitacao: d.dataQuitacao,
        valor: d.valor,
        desconto: d.desconto,
        juro: d.juro,
        multa: d.multa,
        valorTotal: d.valor,
        valorQuitado: d.valorQuitado,
        observacao: d.observacao,
        tipo: { id: d.tipo },
        formaPagamento: { id: d.formaPagamento },
        situacao: d.situacao,
        conta: d.conta ? { id: d.conta } : null,
        ativo: d.ativo,
        qtoRepetido: d.qtoRepetido
      }
    },

    async save(data) {
      // Validações de Quitação no Frontend (Espelhando o Backend)
      const valorQuitado = parseFloat(data.valorQuitado)
      if (valorQuitado && valorQuitado > 0) {
        if (!data.dataQuitacao) {
          this.MensagemError('Validação Crítica', 'Para valores quitados superiores a zero, o preenchimento da data de quitação é obrigatório.')
          return
        }
        if (data.situacao !== 'QUITADO' && data.situacao !== 'PAGO_A_MENOR') {
          this.MensagemError('Validação Crítica', 'Para valores quitados maiores que zero, selecione a situação "Quitado" antes de salvar.')
          return
        }
      }
      
      if (data.dataQuitacao) {
        if (!valorQuitado || valorQuitado <= 0) {
          this.MensagemError('Validação Crítica', 'Você informou a data de quitação, mas o valor quitado está vazio ou igual a zero. Por favor, informe um valor válido.')
          return
        }
      }

      const payload = this.prepareForSave(data)
      const response = await this.$store.dispatch(
        'pagamentoRecebimentoFinancialModule/editPagamentoRecebimento',
        payload
      )
      if (response && response.response) {
        const errs = response.response.data?.errors
        this.MensagemError(
          'Falha ao salvar',
          errs ? errs[0].message : response.response.data?.message
        )
        return
      }
      this.showMessageSuccess('Salvo', 'Transação atualizada com sucesso!')
      this.voltar()
    }
  }
}
</script>
